export const MAX_TEXT_LENGTH = 256;
export const MAX_MULTILINE_TEXT_LENGTH = 512;
const MAX_INGREDIENTS_LENGTH = 20;
const MAX_DIRECTIONS_LENGTH = 10;

export const MAX_FILE_SIZE = 1024 * 1024 * 0.5; // 500 kB

const RecipeValidator = {
  title: (title = '') => {
    const _title = title.trim();

    if (!_title) return 'Recipe title cannot be empty';

    if (_title.length > MAX_TEXT_LENGTH)
      return `Recipe title cannot have more than ${MAX_TEXT_LENGTH} characters`;
  },
  ingredients: (ingredients = []) => {
    if (!ingredients || !ingredients.length)
      return 'Recipe ingredients cannot be empty';

    if (ingredients.length > MAX_INGREDIENTS_LENGTH)
      return `Recipe cannot have more than ${MAX_INGREDIENTS_LENGTH} ingredients`;
  },
  timeToPrepare: (timeToPrepare = '') => {
    if (!timeToPrepare) return 'Time to prepare cannot be empty';
    if (parseInt(timeToPrepare) <= 0)
      return 'Time to prepare must be greater than 0';
  },
  directions: (directions = []) => {
    if (!directions || !directions.length) return 'Directions cannot be empty';

    if (directions.length > MAX_DIRECTIONS_LENGTH)
      return `Recipe cannot have more than ${MAX_DIRECTIONS_LENGTH} directions`;
  },
  additionalData: (additionalData = {}) => {
    const errors = {};
    const { description = '', servings } = additionalData;

    const _description = description.trim();
    if (_description.length > MAX_MULTILINE_TEXT_LENGTH)
      errors.description = `Recipe description cannot have more than ${MAX_MULTILINE_TEXT_LENGTH} characters`;

    if (servings !== '' && parseInt(servings) <= 0)
      errors.servings = 'Must serve at least one person';

    const validateNutricionalData = (nutricionalData = {}) => {
      const keys = ['protein', 'carbohydrate', 'fat', 'calories'];

      const hasAnyFieldSet = () => {
        for (const key of keys) {
          if (nutricionalData[key] !== '') return true;
        }
        return false;
      };

      if (hasAnyFieldSet()) {
        const nutricionalDataErrors = {};

        const validateField = (key) => {
          const captalize = (value = '') =>
            value.charAt(0).toUpperCase() + value.slice(1);
          const value = nutricionalData[key];

          if (!value && value !== 0) return `${captalize(key)} cannot be empty`;
          if (parseInt(value) < 0)
            return `${captalize(key)} cannot be negative`;

          return null;
        };

        for (const key of keys) {
          const error = validateField(key);
          if (error) nutricionalDataErrors[key] = error;
        }

        if (!Object.keys(nutricionalDataErrors).length) return null;
        return nutricionalDataErrors;
      }

      return null;
    };
    const nutricionalDataErrors = validateNutricionalData(
      additionalData.nutricionalData
    );
    if (nutricionalDataErrors) errors.nutricionalData = nutricionalDataErrors;

    if (!Object.keys(errors).length) return null;
    return errors;
  },
};

export default RecipeValidator;
